import { Alert, Dialog, Stack, TextField } from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import type { SubTopicDatabase, SubTopicWithLastActivityWithIdDatabase } from '../../../../types';
import { useUpdateSubTopicModal } from './useUpdateSubTopicModal';

type Props = {
  onClose: () => void;
  subTopic: SubTopicDatabase | SubTopicWithLastActivityWithIdDatabase;
}

export default function UpdateSubTopicModal(props: Props) {
  const hook = useUpdateSubTopicModal(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      onSubmit={hook.onSubmit}
      maxWidth="xs"
      fullWidth
      title="Modifier le sous-sujet"
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Enregistrer',
          type: 'submit',
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={3}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          control={hook.form.control}
          name="name"
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Nom du sous-sujet"
              autoFocus
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      </Stack>
    </Dialog>
  );
}
